// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"571":"65b4e840","846":"08335cb2"}[chunkId] + ".chunk.js";
};